import React from "react"

const IconCssApi = () => {
  return (
    <div>
      <span aria-hidden="true"
          className="pb-icon-sparkles"
      />
    </div>
  )
}

export default IconCssApi
